<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">

          <div class="chat__profile-search flex p-4">
              <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full mx-5 input-rounded-full" placeholder="Procure um pedido" v-model="searchOrder"/>
          </div>

          <vs-divider class="d-theme-border-grey-light m-0" />
          
          <VuePerfectScrollbar class="chat-scroll-area pt-4" :settings="scrollSettings">

              <!-- ACTIVE CHATS LIST -->
              <div class="chat__chats-list mb-8">
                  <h3 class="text-primary mb-5 px-4">FILA</h3>
                  <ul class="chat__active-chats bordered-items">
                      <li class="cursor-pointer">

                        <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}">
                          <div class="contact__avatar mr-1">
                            <a-progress class="mr-2 ml-2" strokeColor="black" strokeWidth="9" type="circle" :width="45" :percent="75" >
                              <template v-slot:format="percent">
                                <span class="block" style="font-size: 12px; color: white">10</span>
                                <span class="block" style="font-size: 12px; color: white">MIN</span>
                              </template>
                            </a-progress>
                          </div>
                          <div class="contact__container w-full flex items-center justify-between overflow-hidden">
                              <div class="contact__info flex flex-col truncate w-5/6">
                                  <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">Pedido AK3S29</h5>
                                  <span class="truncate">7 Itens</span>
                              </div>

                              <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
                                  <span class="whitespace-no-wrap">10:30</span>
                                  <!--<vs-chip class="number" color="primary">Visto</vs-chip>-->
                              </div>
                          </div>
                        </div>

                      </li>
                  </ul>

                  <ul class="chat__active-chats bordered-items">
                      <li class="cursor-pointer">

                        <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': false}">
                          <div class="contact__avatar mr-1">
                              <a-progress class="mr-2 ml-2" strokeColor="black" strokeWidth="9" type="circle" :width="45" :percent="70" >
                                <template v-slot:format="percent">
                                  <span class="block" style="font-size: 12px;">15</span>
                                  <span class="block" style="font-size: 12px;">MIN</span>
                                </template>
                              </a-progress>
                          </div>
                          <div class="contact__container w-full flex items-center justify-between overflow-hidden">
                              <div class="contact__info flex flex-col truncate w-5/6">
                                  <h5 class="font-semibold" :class="{'text-white': false}">Pedido AK3S29</h5>
                                  <span class="truncate">3 Itens</span>
                              </div>

                              <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
                                  <span class="whitespace-no-wrap">10:25</span>
                                  <!--<vs-chip class="number" color="primary">Visto</vs-chip>-->
                              </div>
                          </div>
                        </div>

                      </li>
                  </ul>
              </div>


              <!-- CONTACTS LIST -->
              <!---<div class="chat__contacts">
                  <h3 class="text-primary mb-5 px-4">Contacts</h3>
                  <ul class="chat__contacts bordered-items">
                      <li class="cursor-pointer" v-for="contact in contacts" :key="contact.uid" @click="updateActiveChatUser(contact.uid)">
                          <chat-contact :contact="contact"></chat-contact>
                      </li>
                  </ul>
              </div>-->
          </VuePerfectScrollbar>
      </vs-sidebar>

      <!-- RIGHT COLUMN -->
      <div class="chat__bg no-scroll-content-kitchen chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': selectedOrder === false}">
          <template>
              <div class="chat__navbar">
                
                <div v-if="selectedOrder != null" class="chat__header">
                  <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
                      <div class="relative flex mr-4">
                        <vs-avatar class="m-0 border-2 border-solid border-white" size="40px" src="" />
                      </div>
                      <h4 class="mt-4">Pedido AK3S29</h4>
                      <vs-spacer></vs-spacer>
                      <feather-icon icon="PrinterIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current': true}, 'w-6', 'h-6']"></feather-icon>
                  </vs-navbar>
                </div>

              </div>
              <VuePerfectScrollbar class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="scrollSettings" ref="chatLogPS">
                  <div class="chat__log" ref="chatLog">
                    
                    <div class="vx-row p-4">
                      <div class="vx-col w-full">
                        <vx-card 
                          title="[10:21] - Junior Guedes"
                          title-color="primary">
                          
                          <div>
                            <h5 class="inline"><strong>1 Açai Premium</strong></h5>
                            <span class="ml-4 text-primary"><a-icon type="shopping" /> Para viagem</span>
                          </div>
                          
                          <div class="ml-4">
                            <span class="block"><strong>Complementos</strong></span>

                            <div class="ml-4">
                              <span class="block"> - Flocos de arroz</span>
                              <span class="block"> - Ovomaltine <strong class="text-primary">(2x)</strong></span>
                              <span class="block"> - Paçoca</span>
                            </div>
                          </div>

                          <div class="ml-4 mt-4">
                            <span class="block"><strong>Coberturas</strong></span>

                            <div class="ml-4">
                              <span class="block"> - Chocolate</span>
                              <span class="block"> - Menta</span>
                            </div>
                          </div>

                          <hr/>

                          <div>
                            <h5 class="inline"><strong>1 Salada de Frutas</strong></h5>
                          </div>
                          
                          <div class="ml-4">
                            <span class="block"><strong>Frutas</strong></span>

                            <div class="ml-4">
                              <span class="block"> - Maçã</span>
                              <span class="block"> - Pera <strong class="text-primary">(2x)</strong></span>
                              <span class="block"> - Banana</span>
                              <span class="block"> - Mamão</span>
                            </div>
                          </div>

                          <div class="ml-4 mt-4">
                            <span class="block"><strong>Coberturas</strong></span>

                            <div class="ml-4">
                              <span class="block"> - Leite Condensado</span>
                            </div>
                          </div>

                        </vx-card>
                      </div>
                    </div>


                    <div class="vx-row p-4">
                      <div class="vx-col w-full">
                        <vx-card 
                          title="[10:21] - Vagner Gon"
                          title-color="primary">
                          
                          <div>
                            <h5><strong>1 Açai Premium</strong></h5>
                          </div>
                          
                          <div class="ml-4">
                            <span class="block"><strong>Complementos</strong></span>

                            <div class="ml-4">
                              <span class="block"> - Granulado <strong class="text-primary">(2x)</strong></span>
                              <span class="block"> - Chobol</span>
                            </div>
                          </div>

                          <div class="ml-4 mt-4">
                            <span class="block"><strong>Coberturas</strong></span>

                            <div class="ml-4">
                              <span class="block"> - Chocolate <strong class="text-primary">(2x)</strong></span>
                            </div>
                          </div>
                        </vx-card>
                      </div>
                    </div>

                  </div>
              </VuePerfectScrollbar>
              <div class="chat__input flex p-4 bg-white">
                
                  <vs-button class="bg-primary-gradient ml-4 w-full" type="filled">FINALIZAR PEDIDO</vs-button>
              </div>
          </template>
      </div>
    </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    components : {
      VuePerfectScrollbar
    },

    data () {
      return {
        selectedOrder : true,
        clickNotClose : true,
        isLoggedInUserProfileView : true,
        userProfileId : 'A3XV3',
        isActiveChatUser : true,
        isChatSidebarActive : true,
        searchOrder : '',
        scrollSettings : {
          maxScrollbarLength : 60,
          scrollXMarginOffset :20,
          wheelSpeed         : 0.70,
        }
      }
    }
  }
</script>
<style lang="scss">
@import "@/assets/scss/components/kitchen/kitchen.scss";
</style>